import React from 'react';

class Resources extends React.Component {
    componentDidMount() {
        this.props.updateBreadcrumbs(['Resources']);
    }
    render() {
        return <div />;
    }
}

export default Resources;
